import { defineComponent, computed, openBlock, createElementBlock, createElementVNode, Fragment, renderList, toDisplayString, createCommentVNode, createVNode, unref } from "vue";
import { IconInformationStroke } from "@rei/cedar";
const _hoisted_1 = {
  key: 0,
  class: "oversize__charge-list"
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 2,
  class: "oversize__restrictions"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "OversizeShipModal",
  props: {
    oversizeCharges: {
      default: () => []
    },
    restrictions: {
      default: null
    }
  },
  setup(__props) {
    const props = __props;
    const hasError = computed(() => !props.oversizeCharges || props.oversizeCharges.length < 1);
    function sizeMessage(size) {
      if (!size || size === "NONE") return "";
      return ` on size ${size}`;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [_cache[0] || (_cache[0] = createElementVNode("p", null, " There’s an extra charge to ship heavy or oversize items, including bikes, canoes and roof boxes. ", -1)), !hasError.value ? (openBlock(), createElementBlock("ul", _hoisted_1, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.oversizeCharges, (item) => {
        return openBlock(), createElementBlock("li", {
          key: item.size
        }, " $" + toDisplayString(item.charge) + " oversize charge" + toDisplayString(sizeMessage(item.size)), 1);
      }), 128))])) : createCommentVNode("", true), hasError.value ? (openBlock(), createElementBlock("p", _hoisted_2, " Sorry, we cannot calculate charges at this time. ")) : createCommentVNode("", true), _cache[1] || (_cache[1] = createElementVNode("p", {
        class: "oversize__disclaimer"
      }, " For final shipping price, see checkout. ", -1)), _ctx.restrictions ? (openBlock(), createElementBlock("div", _hoisted_3, [createVNode(unref(IconInformationStroke), {
        class: "restrictions-icon"
      }), createElementVNode("ul", null, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.restrictions, (restriction) => {
        return openBlock(), createElementBlock("li", {
          key: restriction.message
        }, toDisplayString(restriction.message), 1);
      }), 128))])])) : createCommentVNode("", true)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=OversizeShipModal2.mjs.map
